import React from "react";
import TestConfigWrapper from "./TestConfigWrapper/index.jsx";

export default function ABTestCreateConfig() {
    return <TestConfigWrapper />;
}